// Price Bulk Editor — marketing site interactions.
// Vanilla JS only. No React. Keeps the marketing entry small and SSR-friendly.

import './marketing.css';

// ---------------------------------------------------------------------------
// Mobile nav toggle
// ---------------------------------------------------------------------------
function initMobileNav() {
  const trigger = document.querySelector('[data-mobile-nav-toggle]');
  const panel = document.querySelector('[data-mobile-nav-panel]');
  if (!trigger || !panel) return;

  const setOpen = (open) => {
    trigger.setAttribute('aria-expanded', String(open));
    panel.classList.toggle('hidden', !open);
    document.documentElement.classList.toggle('overflow-hidden', open);
  };

  trigger.addEventListener('click', () => {
    const isOpen = trigger.getAttribute('aria-expanded') === 'true';
    setOpen(!isOpen);
  });

  // Close on link click — single-page nav feel
  panel.querySelectorAll('a').forEach((a) =>
    a.addEventListener('click', () => setOpen(false))
  );

  // Close on Escape
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') setOpen(false);
  });
}

// ---------------------------------------------------------------------------
// Copy-to-clipboard for code samples + email addresses
// ---------------------------------------------------------------------------
function initCopyButtons() {
  document.querySelectorAll('[data-copy]').forEach((btn) => {
    btn.addEventListener('click', async () => {
      const value = btn.getAttribute('data-copy');
      if (!value) return;
      try {
        await navigator.clipboard.writeText(value);
        const originalText = btn.textContent;
        btn.textContent = 'Copied';
        btn.classList.add('text-rollback-600');
        setTimeout(() => {
          btn.textContent = originalText;
          btn.classList.remove('text-rollback-600');
        }, 1600);
      } catch (err) {
        // Silent fail — clipboard API can be blocked in iframes / insecure
        // contexts. Marketing site is served over HTTPS so realistic users
        // hit the success path.
      }
    });
  });
}

// ---------------------------------------------------------------------------
// Sticky nav shadow on scroll — subtle, no JS-driven animation
// ---------------------------------------------------------------------------
function initStickyNavShadow() {
  const nav = document.querySelector('[data-sticky-nav]');
  if (!nav) return;
  const onScroll = () => {
    if (window.scrollY > 8) {
      nav.classList.add('shadow-ink-sm', 'border-ink-200');
      nav.classList.remove('border-transparent');
    } else {
      nav.classList.remove('shadow-ink-sm', 'border-ink-200');
      nav.classList.add('border-transparent');
    }
  };
  onScroll();
  window.addEventListener('scroll', onScroll, { passive: true });
}

// ---------------------------------------------------------------------------
// Contact form — progressive enhancement.
// Server still renders the response on full POST, so JS just gives instant
// validation feedback for empty fields.
// ---------------------------------------------------------------------------
function initContactForm() {
  const form = document.querySelector('[data-contact-form]');
  if (!form) return;
  form.addEventListener('submit', (e) => {
    const required = form.querySelectorAll('[required]');
    let invalid = false;
    required.forEach((field) => {
      if (!field.value || (field.type === 'email' && !/.+@.+\..+/.test(field.value))) {
        field.classList.add('input-pb-error');
        invalid = true;
      } else {
        field.classList.remove('input-pb-error');
      }
    });
    if (invalid) {
      e.preventDefault();
    }
  });
}

// ---------------------------------------------------------------------------
// Pricing toggle — annual vs monthly (visual hint only; we don't yet sell
// annual via Shopify Billing API). Left here for future enablement.
// ---------------------------------------------------------------------------
function initPricingToggle() {
  const toggle = document.querySelector('[data-pricing-toggle]');
  if (!toggle) return;
  const prices = document.querySelectorAll('[data-price-monthly][data-price-annual]');
  toggle.addEventListener('change', () => {
    const annual = toggle.checked;
    prices.forEach((el) => {
      el.textContent = annual
        ? el.getAttribute('data-price-annual')
        : el.getAttribute('data-price-monthly');
    });
  });
}

// ---------------------------------------------------------------------------
// Boot
// ---------------------------------------------------------------------------
document.addEventListener('DOMContentLoaded', () => {
  initMobileNav();
  initCopyButtons();
  initStickyNavShadow();
  initContactForm();
  initPricingToggle();
});
